/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DashboardLayout } from '../components/Dashboard';
import { TableGen2 } from '../components/table-gen-2';
import { formatDate_hours, pagesRouter} from '../core/function/function-generic';
import { EyeIcon } from '@heroicons/react/24/outline';
import { SubheaderComponent } from '../components/Subheader';
import { useSelector } from 'react-redux';
import { kycStatus } from '../core/enum';

import { ComplianceController } from '../core/controller/ComplianceCtrl';
import { ToastContainer, toast } from 'react-toastify';
import { toastError } from '../core/toast/toastAlert';
import LoadingComponent from '../components/loading/loading';
import Flag from 'react-world-flags';
import { RegExpValidator } from '../core/regExp-generic';

export const Compliance = ({ onSearchGen }) => {
    const complianceController = new ComplianceController()
    const state = useSelector((state) => state.business)
    const location = useLocation()
    const navigate = useNavigate()
    const [pagesPagination, setpagesPagination] = useState(1)
    const [timeoutId, setTimeoutId] = useState(0);
    const [valuePeriod, setValuePeriod] = useState(null)
    const [valueSearch, setValueSearch] = useState(null)
    const [valueStatus, setValueStatus] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const [dataTable, setDataTable] = useState({
        divContent: 'table-info w-[82%] sm:w-[82%] md:w-full lg:w-full xl:w-full h-[60vh]',
        classTable: 'w-full min-w-max table-auto',
        columns: [
            {
                nameColumn: "Customer ID",
                keysColumns: 'customerid',
                classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb]',
                classStyles: 'pl-4 py-6 text-justify text-[#475467] text-[14px] not-italic font-[Inter] font-normal leading-5'
            },
            {
                nameColumn: "Name",
                keysColumns: 'fullname',
                classThHead: 'text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb]',
                classStyles: 'py-6 text-justify text-[#475467] text-[16px] not-italic font-[Montserrat] font-normal leading-5'
            },
            {
                nameColumn: "Date",
                keysColumns: 'date',
                classThHead: `text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb]`,
                classStyles: 'py-6 text-justify text-[#475467] text-[16px] not-italic font-[Montserrat] font-semibold leading-5'
            },
            {
                nameColumn: "Country",
                keysColumns: 'country',
                classThHead: 'text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb]',
                classStyles: 'py-6 text-justify text-[#475467] text-[16px] not-italic font-[Montserrat] font-semibold leading-5'
            },
            {
                nameColumn: "Status",
                keysColumns: 'status',
                classThHead: 'text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[16px] font-bold  bg-[#f9fafb] ',
                classStyles: 'py-6 w-full flex text-justify text-[#475467] text-[16px] not-italic font-[Montserrat] font-semibold leading-5'
            },
        ],
        data: [],
        classTrBody: 'bord-th-body-table',
        totalPages: 0,
        isAction: true,
        actionIcon: [
            { icon: <EyeIcon className='w-[1.5rem] color-Logout cursor-pointer' />, action: 'view' }
        ],
        iconClass: `border-fff`
    });

    const getComplianceallByBusiness = async (period, status = null, search = null, page, take) => {
        setValuePeriod(period)
        setValueStatus(status)
        setValueSearch(search)
        setisLoading(true)

        const data = {
            "idBusiness": state.id,
            "search": search,
            "period": period,
            "status": status,
            "order": "ASC",
            "page": page,
            "take": take
        }

        if (status === null) delete data.status

        const response = await complianceController.getComplianceallByBusiness(data)

        if (response.statusCode >= 400) {
            setisLoading(false)
            toast.error(response.message, toastError)
            return
        }

        if (response.data.statusCode >= 400) {
            setisLoading(false)
            toast.error(response.message, toastError)
            return
        }

        const resultMap = await complianceController.mapRowDataCompliance(response.data.data.result)
        setDataTable((prevDataTable) => ({
            ...prevDataTable,
            data: resultMap.map((res) => ({
                ...res,
                status: (
                    <div className={`w-[7.5rem] text-justify cursor-default badge ${kycStatus[res.status][1]}`}>
                        <span className={`fontPageTitle600 ${kycStatus[res.status][2]}`}>{kycStatus[res.status][0]}</span>
                    </div>
                ),
                country: (
                    <Flag className="h-[1.0rem] inline-block" code={res.country} />
                )
            })),
            totalPages: response.data.data.result.totalPages
        }))

        setisLoading(false)
    }

    const handleNextPageClick = (e) => {
        setpagesPagination((e.selected + 1));
    }

    const onAction = (event) => {
        if (event.action === 'view') navigate('/compliance/details/' + event.data.customerid)
    }

    const onExportFile = async () => {
        try {
            const today = new Date();
            let params = {
                "idBusiness": state.id,
                "order": "ASC",
                "page": pagesPagination,
                "take": 10
            }

            if (valuePeriod) params["period"] = valuePeriod
            if (valueSearch) params["status"] = valueSearch
            if (valueStatus) params["search"] = valueStatus

            const response = await complianceController.postComplianceDownload(params);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${'compliances' + '_' + formatDate_hours(today)}.csv`);
            document.body.appendChild(link);
            link.click();

        }
        catch (error) {

        }
    }

    const onFilter = async (nameFilter, valueFilter) => {
        if (nameFilter === 'period') {
            setValuePeriod(valueFilter)
            await getComplianceallByBusiness(valueFilter, valueStatus, valueSearch, pagesPagination, 10)
            return
        }

        if (nameFilter === 'status') {
            setValueStatus(valueFilter)
            await getComplianceallByBusiness(valuePeriod, valueFilter, valueSearch, pagesPagination, 10)
            return
        }

        if (nameFilter === 'search') {
            const valueFind = RegExpValidator.numeric.test(valueFilter) ? parseInt(valueFilter) : valueFilter.trim()
            clearTimeout(timeoutId);
            setTimeoutId(setTimeout(async () => {
                await getComplianceallByBusiness(valuePeriod, valueStatus, valueFind, pagesPagination, 10)
            }, 2000));

            setTimeout(() => {
                clearTimeout(timeoutId);
            }, 2000);
            setValueSearch(valueFilter)
            return
        }
    }

    useEffect(() => {
        getComplianceallByBusiness(null, null, null, pagesPagination, 10)
    }, []);

    return (
        <>
            <LoadingComponent isOpen={isLoading} />
            <DashboardLayout pageTitle={pagesRouter(location.pathname)} onSearchGen={onSearchGen} onExportFile={onExportFile}>
                <SubheaderComponent name='Customers' onFilters={onFilter} dataOption="kyc" />
                <TableGen2
                    dataTableGen={dataTable}
                    handleNextPageClick={handleNextPageClick}
                    onAction={onAction}
                />
                <ToastContainer />
            </DashboardLayout>
        </>
    )
}